import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import * as modal from "../util/modal.ts";
import * as FwDatas from "../FwDatas.ts";

import ApiServer from "../ApiServer.ts";
import { SimpleControllerBook } from "../page/ControllerBook.ts";

import Icons from "../svg/Icons.ts";
import {clear as clearSelection, selection} from "../widget/media-selector.ts"
import { GalleryListCache, GalleryCache } from "./GalleryBeans.ts";
import { registerFileDropConsumer, pickFileFromDevice } from "../lib/FileUtils.ts";
import { uploadMultiplePictures } from "../widget/form/input-images.ts";
import { ExecutorES6 } from "../lib/ExecutorES6.ts";
import * as  i18n from "../i18n.ts";
import {template_gallery, template_gallery_content} from "./template_gallery.ts"
import { pickVerifiedFileFromDevice } from "../global_connected.ts";

var ImageLoaderExecutor = new ExecutorES6(5);

function isNodeInScreen(node){
  var rect = node.getBoundingClientRect();
  if(rect.bottom<0) return false;
  if(rect.right<0) return false;
  if(rect.top>window.innerHeight) return false;
  if(rect.left>window.innerWidth) return false;
  return true;
}

function loadImageWithDataSrc(domNode :HTMLElement){
  ImageLoaderExecutor.clearQueue()
  var allVisibleNode = Array.from(domNode.querySelectorAll<HTMLImageElement>('*[data-src]')).filter(isNodeInScreen);

  allVisibleNode.forEach(img=>{
    ImageLoaderExecutor.push(()=>{
      //we recheck
      if(!isNodeInScreen(img)) return;

      return new Promise((resolve,reject)=>{
        var src = img.getAttribute('data-src');
        if(src===null){
          resolve(img)
          return;
        }
        img.removeAttribute('data-src');
        if(img.tagName!=='IMG'){
          img.style.backgroundImage = `url(${src})`
          img = document.createElement('img');
        }
        img.onload = resolve;
        img.onerror = reject;
        img.setAttribute('src',src)

      })
    })

  })
}

INR.onPage(INR.URL.GALLERY,function(){

  var
    leftNode = document.querySelector<HTMLElement>('.pane-left'),
    rightNode = document.querySelector<HTMLElement>('.pane-main'),
    leftUpdater = (items)=>{
      Html.setHtml(leftNode,template_gallery,{
        all:items.find(item=>item.metaId==='albumCover/ALL'),
        favorites:items.find(item=>item.metaId==='albumCover/MOOD_STAR'),
        members:items.filter(item=>item.accountId!==null)
      })
    },
    rightUpdater = async (ID)=>{
      clearSelection()

      var
        [albums,medias] = await Promise.all([GalleryListCache.need(),GalleryCache.need()]),
        head = GalleryListCache.get(ID)||albums[0];

      Html.setHtml(rightNode,template_gallery_content,{
        head,
        content:medias.mediaList.datas.filter(head.getMediaFilter()),
        emptyState:{
          img:head.type==="MOOD_STAR"?'images/empty_state_illustration_gallery_favorites.svg':'images/empty_state_illustration_gallery.svg',
          title:{"ALL":'photos.emptytitleall',"MOOD_STAR":'photos.emptytitlefavorite',"AUTHOR":'photos.emptytitleaccount'}[head.type],
          text:{"ALL":'photos.emptytextall',"MOOD_STAR":'photos.emptytextfavorite',"AUTHOR":'photos.emptytextaccount'}[head.type],
          name:head.type==="AUTHOR"?head.account.firstName:undefined
        }
      })
      //in mobile view the right pane display later, so we need to wait a little
      setTimeout(function(){
        loadImageWithDataSrc(rightNode)
      },10)
      rightNode.querySelector('.flexauto')?.addEventListener('scroll',(evt)=>{
        loadImageWithDataSrc(rightNode)
      })
      amplify.subscribe('resize',(evt)=>{
        loadImageWithDataSrc(rightNode)
      })
    },
    CONTROLLER = new SimpleControllerBook(leftNode,leftUpdater,GalleryListCache,rightNode,rightUpdater)

    //TODO move that in a specific file for reuse
    //and add also an Html listener, and use this everywhere





  amplify.publish("handleParam");
  INR.subscribe('newActivity',function(){
    GalleryCache.refresh()
    CONTROLLER.refresh()
  })

});

registerFileDropConsumer(async function(){
  return {
    nodes:Array.from(document.querySelectorAll('.gallery-album')),
    ondrop(event){
      var files= Array.from(event.dataTransfer.files)
      for(var file of files){
        if(file.type.startsWith('video/')){
          if(!FwDatas.getPermission('videoAvailable')){
            Html.trigger(null,'takepremium')
            return;
          }
        }
      }

      uploadMultiplePictures(files)
    }
  }
})

actionMenu.register({
  async gallerymenu(){
    var
      metaId = Html.getDomMetaId(this),
      album = (await GalleryListCache.get(metaId)),
      medias = (await GalleryCache.need()).mediaList.datas.filter(album.getMediaFilter()),
      buttons :actionMenu.ActionMenuButton[] = [];
    if(album.canAdd){
      buttons.push({svg:Icons.ic_add_image,onclick:"galleryadd",i18nkey:'actions.addphotos'})
    }else{
      buttons.push({svg:Icons.ic_add_image,opacity:0.5,i18nkey:'actions.addphotos'})
    }
    if(selection.size()>0){
      buttons.push(
        {svg:Icons.ic_download,onclick:"selectiondownload",title:i18n.get('actions.downloadN',selection.size())},
        {svg:Icons.ic_delete,onclick:"selectiondelete",title:i18n.get('actions.deleteN',selection.size()),color:"var(--red)"}
      )
    }else{
      if(medias.length===0){
        buttons.push(
          {svg:Icons.ic_download,opacity:0.5,i18nkey:'actions.download'},
          {svg:Icons.ic_delete,opacity:0.5,i18nkey:'actions.delete',color:"var(--red)"}
        )
      }else{
        buttons.push(
          {svg:Icons.ic_download,onclick:"mediadownload",i18nkey:'actions.download'},
          {svg:Icons.ic_delete,onclick:"gallerydelete",i18nkey:'actions.delete',color:"var(--red)"}
        )
      }

    }

    return {'menu':buttons}
  }
})

Html.registerDom({
  async galleryadd(){
    var
      files = await pickVerifiedFileFromDevice("image/*","image/*,video/*",FwDatas.getPermission('videoAvailable'),true);
    if(files.length>0){
      uploadMultiplePictures(files)
    }
  },
  async gallerydelete(){
    var
      album = GalleryListCache.get(Html.getDomMetaId(this)),
      medias = (await GalleryCache.need()).mediaList.datas.filter(album.getMediaFilter()),
      mediasAllowed = medias.filter(media=>media.rights.canDelete),
      isAdmin = medias.length===mediasAllowed.length;

    if(isAdmin){
      if(await modal.confirmDelete({
        title:"photos.confirmdeletetitleadmin",
        message:'photos.confirmdeletealbumadmin',
        yes:'actions.deleteeverything',
        no:"actions.cancel"
      })){
        await ApiServer.metadelete.setOptions({timeout:10000+mediasAllowed.length*1000})(mediasAllowed.map(media=>media.metaId))
        modal.toastDone('photos.toastdeleted',mediasAllowed.length)
        amplify.publish("newActivity")
      }
    }else{
      if(await modal.confirmDelete({
        title:"photos.confirmdeletetitle",
        message:'photos.confirmdeletenotadmin',
        no:"actions.cancel"
      })){
        await ApiServer.metadelete.setOptions({timeout:10000+mediasAllowed.length*1000})(mediasAllowed.map(media=>media.metaId))
        modal.toastDone('photos.toastdeleted',mediasAllowed.length)
        amplify.publish("newActivity")
      }
    }

  }
})

